const deleteAccountUseCase = (repository) => async (id) => {
    return await repository(id);
}

export default deleteAccountUseCase;